import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    appBar: {
        alignItems: 'center',
        bottom: 0,
        background: `linear-gradient(356deg, rgba(2,0,36,1) 3%, rgb(31 85 138) 96%)`,
        display: 'flex',
        justifyContent: 'center',          
        top: 'auto',
        // zIndex: theme.zIndex.drawer - 1,
    },  
    img:{
        height: 20,
        marginRight: 10,
        width: 20,
    },    
    imgTwo:{
        height: 25,
        marginRight: 5,
        width: 25,
    },    
    title: {
        marginRight: 10,
        // fontFamily: 'none',
    },
    lastTitle: {
        marginLeft: 10,
        // fontFamily: 'none',
    },    
}));